function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo, useContext } from "react";
import * as React from "react";
import EventEmitter from "eventemitter3";
import hoistNonReactStatics from "hoist-non-react-statics";
const BusContext = /*#__PURE__*/ React.createContext(new EventEmitter());
const { Provider , Consumer: BusConsumer  } = BusContext;
const BusProvider = (props)=>{
    const eventBus = useMemo(()=>new EventEmitter(), []);
    return /*#__PURE__*/ _jsx(Provider, _objectSpread({
        value: eventBus
    }, props));
};
function withBus(Component) {
    const C = (props)=>/*#__PURE__*/ _jsx(BusConsumer, {
            children: (eventBus)=>/*#__PURE__*/ _jsx(Component, _objectSpread({}, props, {
                    eventBus: eventBus
                }))
        });
    hoistNonReactStatics(C, Component);
    C.displayName = `withBus(${Component.displayName || Component.name || "anonymous"})`;
    return C;
}
function useBus() {
    return useContext(BusContext);
}
export default withBus;
export { BusProvider, BusConsumer, useBus };
